export default __webpack_public_path__ + "static/media/GS_OG.c7d65dbf.svg";